import React from "react";
import PropTypes from "prop-types";

import moment from "moment";

import Controls from "./Controls";
import ChildItem from "./ChildItem";

const Item = ({
	childItems,
	content,
	crud,
	endsAt,
	hasParent,
	hideControls,
	id,
	publishAt,
	singularItemName,
	startsAt,
	subTitle,
	title,
}) => {
	const getTimeAgo = sendAt => {
		const difference = moment(sendAt).diff(moment(), "weeks");
		if (Math.abs(difference) > 4) {
			return moment(sendAt).format("D MMM, YYYY");
		} else {
			return moment(sendAt).fromNow();
		}
	};

	const renderStatus = publishAt => {
		let style, text;
		if (publishAt) {
			if (moment(publishAt).diff(moment()) < 0) {
				style = "success";
				text = "Live";
			} else {
				style = "pending";
				text = `Publishes ${getTimeAgo(publishAt)}`;
			}
		} else {
			style = "draft";
			text = "Draft";
		}
		return (
			<span className={`status ${style}`}>
				<div className="caption-text">{text}</div>
			</span>
		);
	};

	// if you want more default values for child items, put them into this object
	const childItemProps = { endsAt, startsAt };

	return (
		<div className="item">
			{!hideControls && (
				<div className="pull-right">
					<Controls
						id={id}
						crud={crud}
						title={title}
						isChild={hasParent}
						childItemValues={childItemProps}
						singularItemName={singularItemName}
					/>
				</div>
			)}
			<div className="session-content">
				<div className="item-title">
					{title && <h3>{title}</h3>}
					{publishAt !== null && publishAt !== undefined && renderStatus(publishAt || false)}
				</div>
				<div className="item-subtitle">{subTitle && <h5>{subTitle}</h5>}</div>
				{content && <div>{content}</div>}
			</div>
			{childItems && (
				<div className="child-sessions">
					{childItems.map(child => (
						<ChildItem key={child.id} crud={crud} item={child} subTitle={subTitle} />
					))}
				</div>
			)}
		</div>
	);
};

Item.propTypes = {
	childItems: PropTypes.array,
	content: PropTypes.node,
	crud: PropTypes.object,
	endsAt: PropTypes.string,
	hasParent: PropTypes.bool,
	hideControls: PropTypes.bool,
	id: PropTypes.string,
	publishAt: PropTypes.string,
	singularItemName: PropTypes.string,
	startsAt: PropTypes.string,
	subTitle: PropTypes.string,
	title: PropTypes.string,
};

export default Item;
